var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "186.05 106.04 325.6 347.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.75 143.63c-3.3984-1.707-46.699 34.344-46.699 60.91-0.042969 36.27 50.496 118.48 59.02 150.25 7.332 27.266-12.422 59.988-7 61.473 4.9727 3.2031 52.125-44.934 53.969-65.48 2.3633-32.68-55.066-128.03-59.645-152.67-5.3398-28.68 4.1641-53.84 0.35547-54.484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.78 106.11c-4.3359-2.1797-59.551 43.793-59.551 77.672-0.0625 46.246 64.398 151.08 75.266 191.59 9.3281 34.777-15.836 76.496-8.9414 78.379 6.3555 4.0898 66.473-57.289 68.828-83.492 3.0234-41.668-70.223-163.25-76.066-194.68-6.7969-36.578 5.3164-68.652 0.46484-69.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.29 143.63c-3.3945-1.707-46.691 34.344-46.691 60.91-0.054687 36.27 50.488 118.48 59.02 150.25 7.3203 27.266-12.422 59.988-7.0117 61.473 4.9766 3.2031 52.137-44.934 53.969-65.48 2.375-32.68-55.066-128.03-59.641-152.67-5.3398-28.68 4.1641-53.84 0.35547-54.484z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeat);
export default __webpack_public_path__ + "static/media/icon-heat.8e13798b93a5ac0e8e34e8ac71f89de7.svg";
export { ForwardRef as ReactComponent };